import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { FaUserGroup } from "react-icons/fa6";
import DataTable from "react-data-table-component";
import { getliveemployeelist } from "../../../services/TransportService";
import {
  FaUser,
  FaIdBadge,
  FaCheckCircle,
  FaExclamationTriangle,
  FaClock,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { parse, format } from "date-fns";

const EmployeeCard = ({ row }) => {
  const status = row?.status?.toLowerCase();
  const isValid = status === "valid";

  return (
    <div className="card mt-2 px-3 py-2 shadow-sm border rounded-3">
      <div className="d-flex justify-content-between gap-1 mb-1">
        <div className="fw-semibold text-primary d-flex align-items-center">
          <FaUser className="me-1" />
          {row?.employee?.name || "N/A"}
        </div>
        <span
          className={`align-self-start badge rounded-pill px-2 py-1 ${
            isValid
              ? "bg-success-subtle text-success"
              : "bg-warning-subtle text-warning"
          } d-flex align-items-center`}
        >
          {isValid ? (
            <>
              <FaCheckCircle className="me-1" /> Valid
            </>
          ) : (
            <>
              <FaExclamationTriangle className="me-1" /> {row?.status || "N/A"}
            </>
          )}
        </span>
      </div>
      <div className="d-flex justify-content-between gap-1">
        <div className="text-secondary small d-flex align-items-center">
          <FaMapMarkerAlt className="me-1" />
          {row?.stop?.name || "N/A"}
        </div>
        <div className="text-secondary small d-flex align-items-center align-self-start">
          <FaClock className="me-1" />
          {row?.created_at || "N/A"}
        </div>
      </div>
    </div>
  );
};

const Employeereport = ({ rowData }) => {
  const [data, setData] = useState([]);
  const [errorMsg, setErrormsg] = useState("");
  const [totalEmployee, setTotalEmployee] = useState("");
  const [emploading, setEmploading] = useState(false);
  const getEmployeeData = () => {
    setEmploading(true);
    getliveemployeelist(rowData?.id)
      .then((res) => {
        setData(res?.data?.results);
        setTotalEmployee(res?.data?.count);
      })
      .catch((err) => {
        setErrormsg(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setEmploading(false);
      });
  };
  useEffect(() => {
    getEmployeeData();
  }, [rowData]);
  const empColumns = [
    {
      name: "Pass ID",
      selector: (row) => row.pass_id,
      sortable: true,
      wrap: true,
    },
    {
      name: "Name",
      selector: (row) => row?.employee?.name || "N/A",
      sortable: true,
      wrap: true,
    },
    {
      name: "Stop",
      selector: (row) => row.stop || "N/A",
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      width: "100px",
      cell: (row) => (
        <span
          className={`badge text-bg-${
            row.status.toLowerCase() === "valid"
              ? "success-soft"
              : "warning-soft"
          }`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Time",
      width: "100px",
      selector: (row) => {
        if (!row?.timestamp) return "-";

        try {
          const parsedDate = parse(
            row.timestamp,
            "yyyy-MM-dd HH:mm:ss",
            new Date()
          );
          return format(parsedDate, "h:mm a");
        } catch (error) {
          return "-";
        }
      },
    },
  ];
  if (errorMsg) {
    return <div className="alert alert-danger">{errorMsg}</div>;
  }
  return (
    <div>
      {emploading ? (
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : data.length === 0 ? (
        <div className="p-2 text-center">There are no records found.</div>
      ) : (
        <>
          <div>
            <span
              className="offcanvas-title fw-semibold text-dark"
              style={{ fontSize: "1rem" }}
            >
              Employees on ({rowData?.bus?.number_plate || "N/A"})
            </span>
            <badge className="badge bg-primary ms-2">
              Total <FaUserGroup /> {totalEmployee || "NA"}
            </badge>
          </div>
          {/* <div className="table-responsive mt-2">
                <table className="table align-middle mb-0 fs-6">
                  <thead className="custom-thead table-light">
                    <tr>
                      <th>Pass ID</th>
                      <th>Name</th>
                      <th>Stop</th>
                      <th>Status</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody> */}
          {data.map((row, index) => {
            return (
              <EmployeeCard row={row} />
              // <tr key={index}>
              //   <td>{row.bus_pass_id || "N/A"}</td>
              //   <td>{row?.employee?.name || "N/A"}</td>
              //   <td>{row?.stop?.name || "N/A"}</td>
              //   <td>
              //     <span
              //       className={`badge text-bg-${
              //         status === "valid"
              //           ? "success-soft"
              //           : "warning-soft"
              //       }`}
              //     >
              //       {row?.status || "N/A"}
              //     </span>
              //   </td>
              //   <td>{row?.created_at || "N/A"}</td>
              // </tr>
            );
          })}
          {/* </tbody>
                </table>
              </div> */}
        </>
      )}
    </div>
  );
};

export default Employeereport;
